export default "__VITE_ASSET__CCT0I1Df__"